export default __webpack_public_path__ + "assets/images/cfa34a32bb927a4f9874a3db80f9ed67.svg";